import { createSelector } from '@reduxjs/toolkit';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';
import { selectJsonQuery } from './selectJsonQuery';

export const selectRoomsForSale = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('rooms_for_sale')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
